import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { NgSelectComponent } from '@ng-select/ng-select';
import { TranslateService } from '@ngx-translate/core';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { DateTimeAdapter, OwlDateTimeIntl } from 'ng-pick-datetime';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { first } from 'rxjs/operators';
import { Subscription } from '../../../../../node_modules/rxjs';
import { ComboCliente, ComboEstado, ComboGrupo, ComboNgSelect, ComboProveedor, ComboSerieDocumental, ComboTipoServicio } from '../../../core/model/combos';
import { DefaultIntl } from '../../../core/model/datepicker-labels';
import { ResizedEvent } from '../../../core/model/resized-event';
import { ResultadoBusquedaSolicitudes } from '../../../core/model/resultado-busqueda-solicitudes';
import { Situacion } from '../../../core/model/situacion';
import { FilterSolicitudes, Solicitudes, SolicitudesSearch } from '../../../core/model/solicitudes';
import { UsuarioCliente } from '../../../core/model/usuario-cliente';
import { UtcDatePipe } from '../../../core/pipes/utc-date-pipe';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { FiltrosConsultaSolicitudesService } from '../../../core/services/filtros-consulta-solicitudes.service';
import { ParametrosServicioService } from '../../../core/services/parametros-servicio.service';
import { PopulateService } from '../../../core/services/populate.service';
import { SessionService } from '../../../core/services/session.service';
import { SituacionesService } from '../../../core/services/situaciones.service';
import { SolicitudServicioService } from '../../../core/services/solicitud-servicio.service';
import { SolicitudesService } from '../../../core/services/solicitudes.service';
import { UsersService } from '../../../core/services/users.service';
import { UtilitiesService } from '../../../core/services/Utility/utilities.service';


@Component({
  selector: 'app-consulta',
  templateUrl: './consulta.component.html',
  styleUrls: ['./consulta.component.css'],
  providers: [SolicitudesService, PopulateService, { provide: OwlDateTimeIntl, useClass: DefaultIntl }]
})
export class ConsultaComponent implements OnInit, OnDestroy {
  @ViewChild('table') table: DatatableComponent;

  Boxtype = 'box-primary';
  Title: string;
  Description: string;
  Padre: string;
  Hijo: string;

  canReturn: boolean = true;
  isDocoutUser: boolean = undefined;
  isSupervisor = false;
  isAdminUser = false;
  idUniqueCliente: number;
  statusCode: number;
  requestProcessingFilter = false;
  requestProcessingSol = false;
  noHaySolicitudes = false;
  mensajeToShow: string;
  mensajeToShow2: string;
  limitNumber = 10;
  orderField = 'Id';
  orderAsc = false;


  // Modelos formulario
  allSolicitudes: Solicitudes[];
  solicitudesSuscripcion: Subscription;
  totalSolicitudes = 0;

  // ngx-datatable options
  selected = [];
  customMessages = {
    emptyMessage: 'No hay solicitudes disponibles',
    totalMessage: 'Total',
    selectedMessage: 'Selección'
  };
  customClasses = {
    sortAscending: 'fas fa-sort-up',
    sortDescending: 'fas fa-sort-down',
    pagerLeftArrow: 'fas fa-chevron-left',
    pagerRightArrow: 'fas fa-chevron-right',
    pagerPrevious: 'fas fa-step-backward',
    pagerNext: 'fas fa-step-forward'
  };

  tableColumns: any[] = [];

  // combos del formulario
  cbCliente: ComboCliente[];
  cbGrupo: ComboGrupo[];
  cbEstado: ComboEstado[];
  cbFilterSerieDocumental: ComboSerieDocumental[];
  cbTipoServicio: ComboTipoServicio[];
  cbFilterStatistics: ComboNgSelect[] = [];
  cbAfirmacion: ComboNgSelect[] = [];
  cbTransporte: ComboNgSelect[] = [];
  cbDepartamentos: { Id: number, DESCRIPCION: string }[] = [];
  //🥑 proveedor
  cbProveedor: ComboProveedor[];
  mostrarProveedor: boolean = false;

  usuarios: UsuarioCliente[];
  situaciones: Situacion[];
  transporteNormalDisponible = false;
  transporteUrgenteDisponible = false;
  hasAutorizaciones: boolean;
  campos: any = [];

  idDepartamentoFilter: number = null;

  frmGrupoCustomCampos: FormGroup;

  private subscription;
  private subscription_change;
  private subscription_clientes;
  private subscription_grupos;
  private subscription_sol;
  private subscription_serie;
  public bsConfig: BsDatepickerConfig;
  //🥑🥑
  private subscription_proveedores;

  constructor(private solicitudeservice: SolicitudesService,
    private toastr: ToastrService,
    private translateService: TranslateService,
    private populateService: PopulateService,
    private authService: AuthenticationService,
    private utilservice: UtilitiesService,
    private usersService: UsersService,
    private parametrosService: ParametrosServicioService,
    private router: Router,
    private datePipe: DatePipe,
    private utcPipe: UtcDatePipe,
    private dateTimeAdapter: DateTimeAdapter<any>,
    private situacionesService: SituacionesService,
    private activatedRoute: ActivatedRoute,
    private sessionService: SessionService,
    private solicitudService: SolicitudServicioService,
    public filtrosConsultaService: FiltrosConsultaSolicitudesService
  ) {
    dateTimeAdapter.setLocale('es-ES');
  }

  // region Initialize
  ngOnInit() {
    this.SetEnviroment();
    this.InitLanguage();
    this.getAllSolicitudes();
    this.initTableColumns();
    this.hasAutorizaciones = this.authService.hasAutorizaciones();
    this.solicitudService.recoverFieldsFilter().subscribe(
      (p) => {
        this.campos = p;
        let grupo: any = {};
        p.forEach(e => {
          grupo[e.NOMBRE] = new FormControl('');
        });
        this.frmGrupoCustomCampos = new FormGroup(grupo);
      },
      () => {
        this.toastr.error('Ha ocurrido un error al recuperar los campos por los que se pueden filtrar');
      });
  }

  private initTableColumns() {
    this.tableColumns = [
      { name: this.translateService.instant('solicitudes.columns.Id'), prop: 'Id' },
      { name: this.translateService.instant('solicitudes.columns.Client'), prop: 'NOMBRE_CLIENTE' },
      { name: this.translateService.instant('solicitudes.columns.Applicant'), prop: 'USUARIO' },
      { name: this.translateService.instant('solicitudes.columns.Type'), prop: 'TIPO' },
      { name: this.translateService.instant('solicitudes.columns.Priority'), prop: 'PRIORIDAD' },
      { name: this.translateService.instant('solicitudes.columns.State'), prop: 'ESTADO_DESCRIPCION' },
      { name: this.translateService.instant('solicitudes.columns.Situation'), prop: 'SITUACION_DESCRIPCION' },
      { name: this.translateService.instant('solicitudes.columns.InitDate'), prop: 'FECHA_ALTA' },
      { name: this.translateService.instant('solicitudes.columns.LimitDate'), prop: 'FECHA_LIMITE' },
      { name: this.translateService.instant('solicitudes.columns.LastDate'), prop: 'FECHA_FIN' },
      { name: this.translateService.instant('solicitudes.columns.serieDocumental'), prop: 'SERIE_DOCUMENTAL' },
      { name: this.translateService.instant('solicitudes.columns.departamento'), prop: 'ID_DEPARTAMENTO' },
      { name: this.translateService.instant('solicitudes.columns.proveedor'), prop: 'PROVEEDOR' }
    ];

  }


  /**
* Populate the table with new data based on the page number
* @param page The page to select
*/
  setPage(pageInfo: any) {
    this.filtrosConsultaService.page.pageNumber = pageInfo.offset;
    this.searchForm();
  }

  onSort(sortInfo: any) {
    this.orderAsc = sortInfo.sorts[0].dir === 'asc';
    this.orderField = sortInfo.sorts[0].prop.toUpperCase();
    switch (this.orderField) {
      case 'USUARIO': {
        this.orderField = 'SOLICITANTE';
        break;
      }
      case 'ESTADO_DESCRIPCION': {
        this.orderField = 'ESTADO';
        break;
      }
      case 'SITUACION_DESCRIPCION': {
        this.orderField = 'SITUACION';
        break;
      }
      default: { break; }
    }
    this.searchForm();
  }

  InitLanguage() {
    this.subscription = this.translateService.get(['solicitudes'])
      .subscribe(values => { this.TranslateText(values); });

    this.subscription_change = this.translateService.onLangChange.subscribe(() => {
      this.translateService.get(['solicitudes'])
        .subscribe(values => { this.TranslateText(values); });
    });
  }
  TranslateText(values: any) {
    this.Title = values['solicitudes']['cabecera'];
    this.Description = values['solicitudes']['descripcion'];
    this.Hijo = values['solicitudes']['cabecera'];
  }

  SetEnviroment() {

    this.requestDataSelected();

    this.bsConfig = this.utilservice.getDatepickerConfig();

    this.authService.isDocOutUser()
      .then((isDocUser: boolean) => {
        this.isDocoutUser = isDocUser;

        if (this.isSupervisor && !this.isDocoutUser) {
          this.onClientChange([this.sessionService.getClientId()]);
        }

        this.getFilters();
      });

    this.isSupervisor = this.authService.isSupervisorUser() || this.authService.isAdminUser();
    this.isAdminUser = this.authService.isAdminUser();
    this.authService.getClienteName$().subscribe(beadcrumbDad => {
      this.Padre = beadcrumbDad;
    });

    this.idUniqueCliente = this.sessionService.getClientId();
    // this.isSupervisor = this.authService.isSupervisor;

    this.parametrosService.getParams().subscribe((params: string[]) => {
      this.transporteNormalDisponible = params.find(param => param === 'NORMAL') !== undefined;
      this.transporteUrgenteDisponible = params.find(param => param === 'URGENTE') !== undefined;
    });

    this.getSituaciones();

    this.createFilterSolicitudesCombos();

    this.activatedRoute.paramMap.subscribe((params: ParamMap) => {
      const idFilter = +params.get('filterId');
      if (idFilter) {
        const value = +params.get('value');
        const filter = this.filtrosConsultaService.filterSolicitudes.find(filterSolicitud => filterSolicitud.ID == idFilter);
        this.setFilterSelected(filter, value);
      }
    });

    this.canReturn = this.authService.isReturnsAvailable();
  }
  private requestDataSelected() {
    if (this.filtrosConsultaService.clientSelected != '-1') {
      this.onClientChange(this.filtrosConsultaService.clientSelected as number[]);
    }
  }
  private getSituaciones(stateId?: number) {
    this.situacionesService.getSituaciones(stateId)
      .pipe(first()).subscribe((situaciones: Situacion[]) =>
        this.situaciones = situaciones.sort((left, right) =>
          left.descripcion > right.descripcion ? 1 : (left.descripcion === right.descripcion ? 0 : -1)
        )
      );
  }
  private createFilterSolicitudesCombos() {
    this.filtrosConsultaService.filterSolicitudes = this.createFilterSolicitudes();
    this.cbFilterStatistics = this.createFilterStatistics();
    this.cbAfirmacion = this.createFilterAfirmacion();
    this.cbTransporte = this.createFilterTransporte();
  }
  private createFilterTransporte(): ComboNgSelect[] {
    const cbTransporte = [
      this.CreateComboNgSelect(0, this.translateService.instant('solicitudes.normal')),
      this.CreateComboNgSelect(1, this.translateService.instant('solicitudes.urgente')),
    ];

    return cbTransporte;
  }
  private createFilterAfirmacion(): ComboNgSelect[] {
    const cbAfirmacion = [
      this.CreateComboNgSelect(0, this.translateService.instant('generales.si')),
      this.CreateComboNgSelect(1, this.translateService.instant('generales.no')),
    ];

    return cbAfirmacion;
  }
  private setFilterSelected(filter: FilterSolicitudes, value: number) {
    this.filtrosConsultaService.filterForm.controls[filter.propertyForm].setValue(value);
    this.filtrosConsultaService.solicitudesSearch[filter.propertyFilter] = value;
    this.searchForm(true);
  }
  private createFilterStatistics(): ComboNgSelect[] {
    const comboFilterStatistics: ComboNgSelect[] = [];
    comboFilterStatistics.push(this.CreateComboNgSelect(1, this.translateService.instant('solicitudes.statistic.expiredRequests')));
    comboFilterStatistics.push(this.CreateComboNgSelect(2, this.translateService.instant('solicitudes.statistic.almostExpiredRequests')));
    comboFilterStatistics.push(this.CreateComboNgSelect(3, this.translateService.instant('solicitudes.statistic.requestInProgress')));
    comboFilterStatistics.push(this.CreateComboNgSelect(4, this.translateService.instant('solicitudes.statistic.requestsLastMonth')));
    comboFilterStatistics.push(this.CreateComboNgSelect(5, this.translateService.instant('solicitudes.statistic.outstandingLoans')));

    return [...comboFilterStatistics];
  }
  private CreateComboNgSelect(id: number, name: string): ComboNgSelect {
    const ngSelect = new ComboNgSelect();
    ngSelect.ID = id;
    ngSelect.NOMBRE = name;
    return ngSelect;
  }
  private createFilterSolicitudes(): FilterSolicitudes[] {
    const filter = [];
    filter.push(new FilterSolicitudes(1, 'ID_CLIENTE', 'cliente',
      this.translateService.instant('informes.cliente'),
      this.filtrosConsultaService.filterForm.controls['cliente'].value,
      'cbCliente'));
    filter.push(new FilterSolicitudes(2, 'ID_GRUPO', 'grupo',
      this.translateService.instant('informes.grupo'),
      this.filtrosConsultaService.filterForm.controls['grupo'].value,
      'cbGrupo'));
    filter.push(new FilterSolicitudes(3, 'ID_USUARIO', 'usuario',
      this.translateService.instant('solicitudes.solicitante'),
      this.filtrosConsultaService.filterForm.controls['usuario'].value,
      'usuarios'));
    filter.push(new FilterSolicitudes(4, 'Id', 'id', 'Id',
      this.filtrosConsultaService.filterForm.controls['id'].value));
    filter.push(new FilterSolicitudes(5, 'ID_TIPO_SERVICIO', 'servicio',
      this.translateService.instant('generales.service'),
      this.filtrosConsultaService.filterForm.controls['servicio'].value,
      'cbTipoServicio',
      undefined,
      'nombresServicio.'));
    filter.push(new FilterSolicitudes(6, 'ESTADO', 'estado',
      this.translateService.instant('solicitudes.columns.State'),
      this.filtrosConsultaService.filterForm.controls['estado'].value,
      'cbEstado'));
    filter.push(new FilterSolicitudes(7, 'PRIORIDAD', 'prioridad',
      this.translateService.instant('solicitudes.columns.Priority'),
      this.filtrosConsultaService.filterForm.controls['prioridad'].value,
      'cbTransporte'));
    filter.push(new FilterSolicitudes(8, 'FECHA_CREACION_DESDE', 'altadesde',
      this.translateService.instant('generales.from'),
      this.filtrosConsultaService.filterForm.controls['altadesde'].value));
    filter.push(new FilterSolicitudes(9, 'FECHA_CREACION_HASTA', 'altahasta',
      this.translateService.instant('generales.to'),
      this.filtrosConsultaService.filterForm.controls['altahasta'].value));
    filter.push(new FilterSolicitudes(10, 'PDTE_APROBACION', 'pdteaprobacion',
      this.translateService.instant('solicitudes.pendingApproving'),
      this.filtrosConsultaService.filterForm.controls['pdteaprobacion'].value,
      'cbAfirmacion'));
    filter.push(new FilterSolicitudes(11, 'PDTE_APROBAR_POR_USUARIO', 'pdteaprobacionporuser',
      this.translateService.instant('solicitudes.pendingApprovingByUser'),
      this.filtrosConsultaService.filterForm.controls['pdteaprobacionporuser'].value,
      'cbAfirmacion'));
    filter.push(new FilterSolicitudes(12, 'SITUACION', 'situacion',
      this.translateService.instant('solicitudes.situacion'),
      this.filtrosConsultaService.filterForm.controls['situacion'].value,
      'situaciones', 'descripcion'));
    filter.push(new FilterSolicitudes(13, 'FECHA_FINALIZACION', 'fechaFinalizacion',
      this.translateService.instant('solicitudes.fechaFinalizacion'),
      this.filtrosConsultaService.filterForm.controls['fechaFinalizacion'].value));
    filter.push(new FilterSolicitudes(14, 'ESTADISTICAS', 'estadisticas',
      this.translateService.instant('solicitudes.columns.Statistics'),
      this.filtrosConsultaService.filterForm.controls['estadisticas'].value,
      'cbFilterStatistics'));
    filter.push(new FilterSolicitudes(15, 'SERIE_DOCUMENTAL', 'serieDocumental',
      this.translateService.instant('informes.serieDocumental'),
      this.filtrosConsultaService.filterForm.controls['serieDocumental'].value,
      'cbFilterSerieDocumental'));

    //🥑 proveedor
    filter.push(new FilterSolicitudes(16, 'ID_PROVEEDOR', 'proveedor',
      this.translateService.instant('solicitudes.columns.proveedor'),
      this.filtrosConsultaService.filterForm.controls['proveedor'].value,
      'cbProveedor'));
    filter.push(new FilterSolicitudes(1, 'ID_DEPARTAMENTO', 'departamento',
      this.translateService.instant('solicitudes.columns.departamento'),
      this.filtrosConsultaService.filterForm.controls['departamento'].value,
      'cbDepartamentos'));

    return filter;
  }
  // endregion


  // region Combos
  getGroupByCliente(identificador: number) {
    this.subscription_grupos = this.populateService.getComboGrupoByCliente(identificador)
      .subscribe(
        grupo => {
          this.cbGrupo = grupo.sort(function (a, b) {
            if (a.NOMBRE < b.NOMBRE) { return -1; }
            if (a.NOMBRE > b.NOMBRE) { return 1; }
            return 0;
          });
        },
        errorCode => {
          this.statusCode = 500; // errorCode
          this.subscription = this.translateService.get(['mensajes'])
            .subscribe(values => {
              this.toastr.warning(values['mensajes']['nodata'],
                values['mensajes']['nodatatitle']);
            });
        });
  }

  getClientes() {
    this.subscription_clientes = this.populateService.getComboCliente()
      .subscribe(
        clientes => {
          this.cbCliente = clientes.sort(function (a, b) {
            if (a.NOMBRE < b.NOMBRE) { return -1; }
            if (a.NOMBRE > b.NOMBRE) { return 1; }
            return 0;
          });
        },
        errorCode => {
          this.statusCode = 500;
          this.subscription = this.translateService.get(['mensajes'])
            .subscribe(values => {
              this.toastr.warning(values['mensajes']['nodata'],
                values['mensajes']['nodatatitle']);
            });
        });
  }

  getFilters() {
    this.preProcessFilters('Recuperando filtros..');
    if (this.isDocoutUser) {
      this.getClientes();
      this.getTipoServicioByCliente();
    } else {
      this.getTipoServicioByCliente(this.idUniqueCliente);
    }
    this.getEstadosGenerales(0, 0);
    this.getSerieDocumental(null);
    //🥑🥑proveedor
    this.getProveedor(this.idUniqueCliente);
    this.requestProcessingFilter = false;
  }

  getAllSolicitudes(resetPage?: boolean) {
    this.requestProcessingSol = true;
    this.preProcessSolicitudes('Cargando solicitudes... Espere por favor.');
    if (resetPage) {
      this.filtrosConsultaService.page.pageNumber = 0;
    }
    const inicio = this.filtrosConsultaService.page.size * this.filtrosConsultaService.page.pageNumber;
    const fin = inicio + (+this.filtrosConsultaService.page.size);
    if (this.solicitudesSuscripcion) {
      this.solicitudesSuscripcion.unsubscribe();
    }

    this.solicitudesSuscripcion = this.solicitudeservice.getAllSolicitudes(this.filtrosConsultaService.solicitudesSearch, inicio, fin)
      .subscribe((result: ResultadoBusquedaSolicitudes) => {
        this.allSolicitudes = result.subconjuntoSolicitudes;
        this.noHaySolicitudes = result.totalSolicitudes === 0;
        this.totalSolicitudes = result.totalSolicitudes;
        this.requestProcessingSol = false;
      });
  }

  getTipoServicioByCliente(idcliente?: number) {
    this.subscription_clientes = this.populateService.getComboTipoServicioByCliente(idcliente)
      .subscribe(
        tiposservicio => {
          this.cbTipoServicio = tiposservicio.sort(function (a, b) {
            if (a.NOMBRE < b.NOMBRE) { return -1; }
            if (a.NOMBRE > b.NOMBRE) { return 1; }
            return 0;
          });

        },
        errorCode => {
          this.statusCode = 500; // errorCode
          this.subscription = this.translateService.get(['mensajes'])
            .subscribe(values => {
              this.toastr.warning(values['mensajes']['nodata'],
                values['mensajes']['nodatatitle']);
            });
        });
  }

  getEstadosGenerales(idcliente: number, idservicio: number) {
    this.subscription_clientes = this.populateService.getComboEstadoGenerales(idcliente, idservicio)
      .subscribe(
        estados => {
          this.cbEstado = estados.sort(function (a, b) {
            if (a.NOMBRE < b.NOMBRE) { return -1; }
            if (a.NOMBRE > b.NOMBRE) { return 1; }
            return 0;
          });
        },
        errorCode => {
          this.statusCode = 500; // errorCode
          this.subscription = this.translateService.get(['mensajes'])
            .subscribe(values => {
              this.toastr.warning(values['mensajes']['nodata'],
                values['mensajes']['nodatatitle']);
            });
        });
  }

  getSerieDocumental(idcliente?: number, iddepartamento?: number) {
    this.subscription_serie = this.populateService.getComboSerieDocumentales(idcliente, iddepartamento)
      .subscribe(
        serie => {
          if (serie != null) {
            this.cbFilterSerieDocumental = serie.sort(function (a, b) {
              if (a.NOMBRE < b.NOMBRE) { return -1; }
              if (a.NOMBRE > b.NOMBRE) { return 1; }
              return 0;
            });
          }
        },
        errorCode => {
          this.statusCode = 500; // errorCode
          this.subscription = this.translateService.get(['mensajes'])
            .subscribe(values => {
              this.toastr.warning(values['mensajes']['nodata'],
                values['mensajes']['nodatatitle']);
            });
        });
  }

  getDepartamentos(idcliente?: number) {
    this.subscription = this.populateService.getComboDepartamentos(idcliente)
      .subscribe(
        (p) => {
          this.cbDepartamentos = p.sort(function (a, b) {
            if (a.DESCRIPCION < b.DESCRIPCION) { return -1; }
            if (a.DESCRIPCION > b.DESCRIPCION) { return 1; }
            return 0;
          });
        },
        () => {
          this.statusCode = 500;
          this.subscription = this.translateService.get(['mensajes'])
            .subscribe(values => {
              this.toastr.warning(values['mensajes']['nodata'],
                values['mensajes']['nodatatitle']);
            });
        }
      )
  }

  //🥑🥑 Proveedores
  getProveedor(idcliente?: number) {

    if (idcliente === 0 && this.filtrosConsultaService.clientSelected.length > 1) {
      this.mostrarProveedor = false;
    }
    else {

      if (idcliente === 0 || idcliente === undefined) {
        idcliente = 1;
      }

      this.subscription_proveedores = this.populateService.getComboProveedores(idcliente)
        .subscribe(
          (p) => {
            this.mostrarProveedor = true;
            this.cbProveedor = p.sort(function (a, b) {
              if (a.NOMBRE < b.NOMBRE) { return -1; }
              if (a.NOMBRE > b.NOMBRE) { return 1; }
              return 0;
            });
          },
          errorCode => {
            this.mostrarProveedor = false;
            if (errorCode.status == 403) {
              this.toastr.warning('No se cumplen los requisitos para poder filtrar por el campo Proveedores', 'SIN PERMISO');
            }
            else {
              this.toastr.warning('Error cargando el filtro de Proveedores', 'PROVEEDORES');
            }
          });
    }
  }

  onServicioChange(idservicio: number) {
    // limpiamos y posicionamos el combo de estado dependiente de servicios
    this.filtrosConsultaService.filterForm.patchValue({ estado: '-1' });
    this.cbEstado = [];
    if (idservicio !== null && idservicio > -1) {
      this.getEstadosGenerales(this.idUniqueCliente, idservicio);
    } else {
      this.getEstadosGenerales(this.idUniqueCliente, 0);
    }
  }

  onStateChange(idstate: number) {
    // limpiamos y posicionamos el combo de estado dependiente de servicios
    this.filtrosConsultaService.filterForm.patchValue({ situacion: '-1' });
    this.situaciones = [];
    const stateId = idstate > 0 ? idstate : null;
    this.getSituaciones(stateId);
  }

  onClientChange(idscliente: Array<number>) {
    // limpiamos y posicionamos todos los combos dependientes
    this.removeCurrentFilters();
    if (this.isDocoutUser) {
      if ((idscliente === null || idscliente === undefined) || (idscliente !== undefined && idscliente !== null && idscliente.length > 1)) {
        this.idUniqueCliente = 0;
      } else {
        if (idscliente !== undefined && idscliente !== null) {
          this.idUniqueCliente = +idscliente;
        }
      }
    }

    this.getGroupByCliente(this.idUniqueCliente);
    this.getUsers();
    this.getTipoServicioByCliente(this.idUniqueCliente);
    this.getEstadosGenerales(this.idUniqueCliente, 0);
    this.getSerieDocumental(this.idUniqueCliente);
    this.getDepartamentos(this.idUniqueCliente);
    this.getProveedor(this.idUniqueCliente);

  }

  onDepartamentChange(iddepartamento: number) {
    this.getSerieDocumental(this.idUniqueCliente, iddepartamento);
  }

  private getUsers() {
    if (this.idUniqueCliente === undefined) {
      return;
    }
    this.usersService.getUsersByClient(this.idUniqueCliente).subscribe((users: UsuarioCliente[]) => {
      this.usuarios = users.sort(function (a, b) {
        if (a.NOMBRE < b.NOMBRE) { return -1; }
        if (a.NOMBRE > b.NOMBRE) { return 1; }
        return 0;
      });
    });
  }

  onGroupChange() {
    this.filtrosConsultaService.idUsuario = undefined;
    this.usersService.getUsersByClient(this.idUniqueCliente).subscribe((users: UsuarioCliente[]) => {
      this.usuarios = users.filter((user: UsuarioCliente) => {
        return user.ID_GRUPO === +this.filtrosConsultaService.idGrupo;
      });
    });
  }

  // endregion



  // region Formulario
  preProcessFilters(mensaje: string) {
    this.statusCode = null;
    this.requestProcessingFilter = true;
    this.mensajeToShow = mensaje;
  }
  preProcessSolicitudes(mensaje: string) {
    this.statusCode = null;
    this.requestProcessingSol = true;
    this.mensajeToShow2 = mensaje;
  }

  resetForm() {
    this.filtrosConsultaService.filterForm.patchValue({ cliente: undefined });
    this.filtrosConsultaService.filterForm.patchValue({ pdteaprobacion: '-1' });
    this.filtrosConsultaService.filterForm.patchValue({ pdteaprobacionporuser: '-1' });
    this.filtrosConsultaService.filterForm.patchValue({ estadisticas: '-1' });
    this.filtrosConsultaService.filterForm.patchValue({ prioridad: '-1' });
    this.filtrosConsultaService.filterForm.patchValue({ situacion: '-1' });
    this.filtrosConsultaService.filterForm.patchValue({ fFinalizacionComparator: 1 });
    this.filtrosConsultaService.filterForm.patchValue({ id: '' });
    //🥑
    this.filtrosConsultaService.filterForm.patchValue({ serieDocumental: '-1' });
    this.filtrosConsultaService.filterForm.patchValue({ proveedor: '-1' });
    this.filtrosConsultaService.filterForm.patchValue({ fechaFinalizacion: undefined });

    this.removeFilters(this.filtrosConsultaService.filterSolicitudesSelected);
    this.filtrosConsultaService.clientSelected = null;
    this.removeCurrentDates();
    this.getSituaciones(null);
    this.onClientChange([this.idUniqueCliente]);
    //🥑
    this.getSerieDocumental(this.idUniqueCliente);
    //🥑 proveedor
    this.getProveedor(this.idUniqueCliente);
    this.filtrosConsultaService.filterForm.patchValue({ proveedor: '-1' });
  }
  private removeCurrentDates() {
    this.filtrosConsultaService.filterForm.patchValue({ altahasta: '' });
    this.filtrosConsultaService.filterForm.patchValue({ altadesde: '' });
    this.filtrosConsultaService.filterForm.patchValue({ fechaFinalizacion: '' });
  }
  private removeCurrentFilters() {
    this.filtrosConsultaService.filterForm.patchValue({ estado: '-1' });
    this.filtrosConsultaService.filterForm.patchValue({ servicio: '-1' });
    this.filtrosConsultaService.filterForm.patchValue({ grupo: undefined });
    this.filtrosConsultaService.filterForm.patchValue({ usuario: undefined });
    this.cbEstado = [];
    this.cbTipoServicio = [];
    this.cbGrupo = [];
    this.cbFilterSerieDocumental = [];
    //🥑 proveedor
    this.cbProveedor = [];
  }

  searchForm(resetPage?: boolean) {
    this.filtrosConsultaService.solicitudesSearch.ID_TIPO_SERVICIO = this.filtrosConsultaService.filterForm.controls['servicio'].value === '-1'
      ? null : this.filtrosConsultaService.filterForm.controls['servicio'].value;
    this.filtrosConsultaService.solicitudesSearch.Id = this.filtrosConsultaService.filterForm.controls['id'].value === ''
      ? null : this.filtrosConsultaService.filterForm.controls['id'].value;
    this.filtrosConsultaService.solicitudesSearch.ESTADO = this.filtrosConsultaService.filterForm.controls['estado'].value === '-1'
      ? null : this.filtrosConsultaService.filterForm.controls['estado'].value;
    this.filtrosConsultaService.solicitudesSearch.PDTE_APROBACION = this.filtrosConsultaService.filterForm.controls['pdteaprobacion'].value === '-1' ? null
      : !+this.filtrosConsultaService.filterForm.controls['pdteaprobacion'].value;
    this.filtrosConsultaService.solicitudesSearch.PDTE_APROBAR_POR_USUARIO =
      this.filtrosConsultaService.filterForm.controls['pdteaprobacionporuser'].value === '-1' ? null
        : !+this.filtrosConsultaService.filterForm.controls['pdteaprobacionporuser'].value;

    let dvalue = this.filtrosConsultaService.filterForm.controls['altadesde'].value;

    if (!isNaN(dvalue) && dvalue) {
      dvalue = this.datePipe.transform(this.utcPipe.transform(this.filtrosConsultaService.filterForm.controls['altadesde'].value), 'yyyy-MM-dd HH:mm:');
      dvalue += '00';
    } else {
      dvalue = null;
    }

    let hvalue = this.filtrosConsultaService.filterForm.controls['altahasta'].value;
    if (!isNaN(hvalue) && hvalue) {
      hvalue = this.datePipe.transform(this.utcPipe.transform(this.filtrosConsultaService.filterForm.controls['altahasta'].value), 'yyyy-MM-dd HH:mm:');
      hvalue += '59';
    } else {
      hvalue = null;
    }

    this.filtrosConsultaService.solicitudesSearch.FECHA_CREACION_DESDE = dvalue;
    this.filtrosConsultaService.solicitudesSearch.FECHA_CREACION_HASTA = hvalue;

    this.filtrosConsultaService.solicitudesSearch.PRIORIDAD = this.filtrosConsultaService.filterForm.controls['prioridad'].value === '-1'
      ? null : this.filtrosConsultaService.filterForm.controls['prioridad'].value;
    this.filtrosConsultaService.solicitudesSearch.ID_GRUPO = this.filtrosConsultaService.filterForm.controls['grupo'].value === '-1'
      ? null : this.filtrosConsultaService.filterForm.controls['grupo'].value;
    this.filtrosConsultaService.solicitudesSearch.ID_CLIENTE = this.filtrosConsultaService.filterForm.controls['cliente'].value === '-1'
      ? null : this.filtrosConsultaService.filterForm.controls['cliente'].value;
    this.filtrosConsultaService.solicitudesSearch.ID_USUARIO = this.filtrosConsultaService.idUsuario === undefined
      ? null : this.filtrosConsultaService.idUsuario;
    this.filtrosConsultaService.solicitudesSearch.ORDENACION = this.orderField;
    this.filtrosConsultaService.solicitudesSearch.ASC = this.orderAsc;
    this.filtrosConsultaService.solicitudesSearch.SITUACION = this.filtrosConsultaService.filterForm.controls['situacion'].value === '-1'
      ? null : this.filtrosConsultaService.filterForm.controls['situacion'].value;
    const fFin: Date = this.filtrosConsultaService.filterForm.controls['fechaFinalizacion'].value;
    if (fFin) {
      fFin.setHours(0, 0, 0, 0);
      this.filtrosConsultaService.solicitudesSearch.FECHA_FINALIZACION = fFin;
    } else {
      this.filtrosConsultaService.solicitudesSearch.FECHA_FINALIZACION = null;
    }
    this.filtrosConsultaService.solicitudesSearch.FECHA_FINALIZACION_COMPARATOR =
      this.filtrosConsultaService.filterForm.controls['fFinalizacionComparator'].value;
    this.filtrosConsultaService.solicitudesSearch.ESTADISTICAS = this.filtrosConsultaService.filterForm.controls['estadisticas'].value === '-1'
      ? null : this.filtrosConsultaService.filterForm.controls['estadisticas'].value;
    //🥑
    this.filtrosConsultaService.solicitudesSearch.SERIE_DOCUMENTAL = this.filtrosConsultaService.filterForm.controls['serieDocumental'].value === '-1'
      ? null : this.filtrosConsultaService.filterForm.controls['serieDocumental'].value;

    // 🐱‍👤
    this.filtrosConsultaService.solicitudesSearch.ID_DEPARTAMENTO = this.filtrosConsultaService.filterForm.controls['departamento'].value === '-1'
      ? null : this.filtrosConsultaService.filterForm.controls['departamento'].value;

    //🥑 proveedor
    this.filtrosConsultaService.solicitudesSearch.ID_PROVEEDOR = this.filtrosConsultaService.filterForm.controls['proveedor'].value === '-1'
      ? null : this.filtrosConsultaService.filterForm.controls['proveedor'].value;

    this.filtrosConsultaService.filterSolicitudesSelected = this.getFiltersSolicitudesSelected(this.filtrosConsultaService.solicitudesSearch);
    if (this.campos != null && this.campos.length > 0) {
      console.log(this.frmGrupoCustomCampos.value);
      this.filtrosConsultaService.solicitudesSearch.filtrosAvanzados = this.campos.map(k => { return { NOMBRE_CAMPO: k.NOMBRE, VALOR_CAMPO: this.frmGrupoCustomCampos.value[k.NOMBRE] }; });// this.frmGrupoCustomCampos.value;
    }

    this.getAllSolicitudes(resetPage);
  }

  private getFiltersSolicitudesSelected(solicitudesSearch: SolicitudesSearch): FilterSolicitudes[] {
    const filterSolicitudes: FilterSolicitudes[] = [];

    Object.keys(solicitudesSearch).map(property => {
      const filterSolicitud = this.filtrosConsultaService.filterSolicitudes.find((filter: FilterSolicitudes) => filter.propertyFilter == property);
      if (!!filterSolicitud && solicitudesSearch[property] != null && (solicitudesSearch[property] != undefined || solicitudesSearch[property].length)) {
        filterSolicitud.textValue = this.getFilterSolicitudValue(filterSolicitud);
        filterSolicitudes.push(filterSolicitud);
      }
    });

    this.filtrosConsultaService.filterSolicitudesSelectedIds = filterSolicitudes.map(filter => filter.ID);

    return [...filterSolicitudes];
  }
  private getFilterSolicitudValue(filterSolicitud: FilterSolicitudes): string {
    let value = this.filtrosConsultaService.filterForm.controls[filterSolicitud.propertyForm].value;
    if (filterSolicitud.nameComboData) {
      const comboData = this[filterSolicitud.nameComboData];
      const property = !comboData ? '' : comboData[0].hasOwnProperty('Id') ? 'Id' : comboData[0].hasOwnProperty('ID') ? 'ID' : 'id';
      if (!(value instanceof Array)) {
        const valueCombo = comboData.find(combo => combo[property] == value);
        value = !filterSolicitud.propertyInComboData ? valueCombo.NOMBRE : valueCombo[filterSolicitud.propertyInComboData];
        value = this.getTextWithTranslate(value, filterSolicitud.translateTextValue);
      } else {
        const valuesCombo = comboData.filter(combo => value.some(v => v === combo[property]));
        let values = !filterSolicitud.propertyInComboData
          ? valuesCombo.map(v => v.NOMBRE)
          : valuesCombo.map(v => v[filterSolicitud.propertyInComboData]);
        values = values.map(val => this.getTextWithTranslate(val, filterSolicitud.translateTextValue));

        value = values.join(', ');
      }
    }
    if (value instanceof Date) {
      value = this.dateToString(value);
    }
    return filterSolicitud.stringTraslate + ' ( ' + value + ' )';
  }
  private getTextWithTranslate(value: any, translateTextValue: string): any {
    if (!translateTextValue) {
      return value;
    }
    return this.translateService.instant(translateTextValue + value);
  }
  private dateToString(value: Date): any {
    const dateString = value.toLocaleString(localStorage.getItem('idioma'));
    return dateString.split(' ')[0];
    // const dates = dateString.split(' ');
    // const hour = dates[1].split(':')[0] + ':' + dates[1].split(':')[1];
    // return dates[0].replace(',', '') + ' ' + hour;
  }

  // end region

  // region "Eventos datatable"
  viewDetail(identificador: string) {
    this.router.navigate(['docout', { outlets: { contenido: ['detalle', identificador] } }]);
  }

  // endregion

  onResized(event: ResizedEvent): void {
    if (this.table) {
      setTimeout(() => {
        this.table.recalculate();
        window.dispatchEvent(new Event('resize'));
      }, (50));
    }
  }


  ngOnDestroy() {
    // console.log('Clear consulta de prestamos');
    if (this.subscription != null) { this.subscription.unsubscribe(); }
    if (this.subscription_sol != null) { this.subscription_sol.unsubscribe(); }
    if (this.subscription_change != null) { this.subscription_change.unsubscribe(); }
    if (this.subscription_clientes != null) { this.subscription_clientes.unsubscribe(); }
    if (this.subscription_grupos != null) { this.subscription_grupos.unsubscribe(); }
    if (this.subscription_proveedores != null) { this.subscription_proveedores.unsubscribe(); }
    this.translateService = null;
    this.populateService = null;
    this.solicitudeservice = null;
    this.toastr = null;
    this.utilservice = null;
  }

  exportData() {
    this.translateService.get(['mensajes'])
      .subscribe(values => {
        this.toastr.info(values['mensajes']['downloadfileinprogress']);
      });
    this.solicitudesSuscripcion = this.solicitudeservice.getAllSolicitudes(this.filtrosConsultaService.solicitudesSearch, 0, this.totalSolicitudes)
      .subscribe((result: ResultadoBusquedaSolicitudes) => {
        const csv = this.generateCSVFromValues(result);

        const fileName = this.translateService.instant('solicitudes.solicitudes') + '.csv';

        this.utilservice.downloadDataInCSV(fileName, csv);
      });
  }

  private getColumnsForUser(): any[] {
    const columns: any[] = [];
    this.tableColumns.forEach(column => {
      if ((column.prop != 'NOMBRE_CLIENTE' && column.prop != 'USUARIO') || this.isDocoutUser) {
        columns.push(column);
      }
    });

    return columns;
  }

  private generateCSVFromValues(result: ResultadoBusquedaSolicitudes): string {
    const columns = this.getColumnsForUser();
    let csvString = this.convertValuesToCSVRow(columns.map(column => column.name));

    result.subconjuntoSolicitudes.forEach(subconjuntoSolicitud => {
      csvString += this.convertValuesToCSVRow(columns.map(column => this.getSubconjuntoSolicitudData(column.prop, subconjuntoSolicitud)));
    });

    return csvString;
  }

  private getSubconjuntoSolicitudData(prop: string, subconjuntoSolicitud: any): string {
    if (prop == 'PRIORIDAD') {
      const keyTranslate = subconjuntoSolicitud[prop] == 0 ? 'generales.normal' : 'generales.urgente';
      return this.translateService.instant(keyTranslate);
    }

    return subconjuntoSolicitud[prop];
  }

  private convertValuesToCSVRow(values: any[]): string {
    return values.join(';') + '\n';
  }

  aprobarSolicitud(idSolicitud) {
    this.solicitudeservice.aprobarSolicitud(idSolicitud, 1)
      .subscribe((response: Solicitudes) => {
        const datosSolicitud: Solicitudes = this.allSolicitudes.find(solicitud => solicitud.Id == response.Id);
        const index = this.allSolicitudes.indexOf(datosSolicitud);

        if (index !== -1) {
          this.allSolicitudes[index] = response;
        }
      });
  }

  makeReturn(row: Solicitudes) {
    if (row.canReturn) {
      this.router.navigate(['docout', {
        outlets: {
          contenido: ['servicio', 'devolucion', {
            idSolicitudDevolucion: row.Id
          }]
        }
      }]);
    }
  }

  removeFilter(filter) {
    const filterRemoved: FilterSolicitudes = filter.value as FilterSolicitudes;
    this.removeFilters([filterRemoved]);
  }

  removeAllFilters() {
    this.removeFilters(this.filtrosConsultaService.filterSolicitudesSelected);
  }

  private removeFilters(filters: FilterSolicitudes[]) {
    filters.forEach(filter => {
      this.filtrosConsultaService.filterSolicitudesSelected =
        this.filtrosConsultaService.filterSolicitudesSelected.filter(filterSelected => filterSelected.ID != filter.ID);
      this.filtrosConsultaService.filterSolicitudesSelectedIds =
        this.filtrosConsultaService.filterSolicitudesSelectedIds.filter(filterSelectedId => filterSelectedId != filter.ID);
      this.filtrosConsultaService.filterForm.controls[filter.propertyForm].setValue(filter.initFormValue);
      filter.textValue = undefined;
    });

    this.searchForm(true);
  }

  isClientChecked(clientId) {
    const value = this.filtrosConsultaService.filterForm.controls['cliente'].value;
    const isMultivalue = value instanceof Array;
    return value && (value === clientId || (isMultivalue && value.some(v => v === clientId)));
  }

  manageClients(clientSelect: NgSelectComponent) {
    const value = this.filtrosConsultaService.filterForm.controls['cliente'].value;
    this.resizeSelect(clientSelect);
    if (value instanceof Array && value.length === this.cbCliente.length) {
      const filterCliente = this.filtrosConsultaService.filterSolicitudes.find(filter => filter.propertyForm === 'cliente');
      this.filtrosConsultaService.filterForm.controls['cliente'].setValue(filterCliente.initFormValue);
      return;
    }

    const ids = this.cbCliente.map(client => client.Id);
    this.filtrosConsultaService.filterForm.controls['cliente'].setValue(ids);
  }


  resizeSelect(clientSelect: NgSelectComponent) {
    clientSelect.close();
    setTimeout(function () {
      clientSelect.open();
    }, 50);
  }

  isAllClientsSelected() {
    const value = this.filtrosConsultaService.filterForm.controls['cliente'].value;
    return value instanceof Array && value.length === this.cbCliente.length;
  }

  isAnyClientSelected() {
    const value = this.filtrosConsultaService.filterForm.controls['cliente'].value;
    return value instanceof Array && value.length;
  }

  isMoreOneClientSelected() {
    const value = this.filtrosConsultaService.filterForm.controls['cliente'].value;
    return !!value &&
      (value instanceof Array) &&
      value.length > 1;
  }

  clearItem(clearFunction, item, ngSelectSelected) {
    clearFunction(item);
    this.resizeSelect(ngSelectSelected);
  }


}
